import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsContextSlice } from './get';
import { patchCoreSonarObjectsContextSlice } from './patch';

export const coreSonarObjectsContextReducers = combineReducers({
	get: getCoreSonarObjectsContextSlice.asyncReducers,
	patch: patchCoreSonarObjectsContextSlice.asyncReducers
});

export const coreSonarObjectsContextWatchers = combineAllWatchers([
	getCoreSonarObjectsContextSlice.asyncWatchers,
	patchCoreSonarObjectsContextSlice.asyncWatchers
]);
